import { Component } from './component-base.js';
import { ThemeBus } from './events-bus.js';
import { EVENTS } from './event-constants.js';
import { updateCartBubble } from './utilities.js';
import IsLoading from './is-loading.js';

export class SingleQuickBuy extends Component {
    constructor() {
        super();

        this.productId = this.dataset.productId;
        this.isLoading = new IsLoading(this, false);
    }

    connectedCallback() {
        this.addEventListener('click', (event) => {
            if (event.target.closest('[data-quick-buy-product-id]')) {
                event.preventDefault();
                event.stopPropagation();
                this.handleAddToCart(event);
            }
        });
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.handleAddToCart);
    }

    handleAddToCart(event) {
        if (event.target.closest('[data-quick-buy-product-id]') !== this) return;

        const variantId = parseInt(this.dataset.quickBuyProductId);

        if (!variantId) return;

        const url = `/cart/add.js`;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
            }),
        };

        try {
            this.isLoading.setIsLoading(true);

            fetch(url, options)
            .then(response => {                
                if (response.ok) {
                    updateCartBubble();

                    try {
                        ThemeBus.dispatchEvent(new Event(EVENTS.cartUpdated));

                        setTimeout(() => {
                            this.isLoading.setIsLoading(false);
                        }, 500);
                    } 
                    catch (_) {}
                
                    try {
                        ThemeBus.dispatchEvent(new Event(EVENTS.cartItemAdded));

                        setTimeout(() => {
                            this.isLoading.setIsLoading(false);
                        }, 500);
                     } 
                     catch (_) {}
                }
            })
            .catch(error => {
                console.warn('Add to cart failed:', error);
                this.isLoading.setIsLoading(false);
                this.showErrorMessage();
            });
        } catch (error) {
            console.warn('Error adding to cart:', error);
            this.isLoading.setIsLoading(false);
            this.showErrorMessage();
        }
    }
}

if (!customElements.get('single-quick-buy')) {
  customElements.define('single-quick-buy', SingleQuickBuy);
}
